import './dom-11141778.js';
import { i as isArray } from './isArray-135d4ff2.js';
import { i as isNil } from './isNull-ef42547d.js';
import { i as isObject } from './isObject-fb5a9ae7.js';

/**
 * Determines whether the `value` is an empty object, an empty array, a zero-length string, `null`, or `undefined`.
 */
const isEmpty = value => {
  if (isNil(value)) {
    return true;
  }
  if (isString(value)) {
    return value.length === 0;
  }
  if (isArray(value)) {
    return value.length === 0;
  }
  if (isObject(value)) {
    return Object.keys(value).length === 0;
  }
  return false;
};

/**
 * Determines whether the `value` is a string.
 */
const isString = value => {
  return typeof value === 'string';
};

export { isString as a, isEmpty as i };
